import { Component, Prop, Watch, Vue } from 'vue-property-decorator';

import { LoyaltyInfo } from '@/core/payment-card/interfaces';
import { LoyaltyOffer } from '@/core/payment-card/interfaces/loyalty-offer';

@Component({
    data() {
        return {
            selectedOffer: {}
        };
    }
})
export default class LoyaltySingleOffer extends Vue {
    @Prop(Object)
    loyaltyInfo: LoyaltyInfo;

    @Prop(Boolean)
    loading: boolean;

    selectedOffer: LoyaltyOffer;

    @Watch('selectedOffer')
    onChangeSelectedOffer() {
        this.$emit('input', this.selectedOffer.discountAmount || 0);
        this.$emit('select', [this.selectedOffer.offerCode]);
    }

    selectOffer(offer: LoyaltyOffer) {
        if (!this.loading) {
            this.selectedOffer = offer;
        }
    }
}
